/* eslint-disable react/jsx-pascal-case */
import React, { useState } from 'react'
import styled from 'styled-components'
import { Box, Button, Card, Flex, Image, Stamp, Text } from 'pcln-design-system'
import PricebreakersPromo1 from '../../../assets/images/promos/pricebreakers/One.svg'
import PricebreakersPromo2 from '../../../assets/images/promos/pricebreakers/Two.svg'
import PricebreakersPromo3 from '../../../assets/images/promos/pricebreakers/Three.svg'
import PromoModal from '../Modal/PromoModal'
import analytics from '../../../utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '../../../constants/analytics'
import { handleSubmitForPricebreakers } from '../../Hotels/SearchForm/utils'
import { PromoDeal } from '../../Hotels/constants'

const StyledButton = styled(Button)`
  ${props => props.theme.mediaQueries[0]} {
    height: 65px;
    width: 224px;
  }
  ${props => props.theme.mediaQueries[3]} {
    height: 48px;
  }
  font-size: 16px;
  height: 48px;
  margin-left: auto;
  line-height: 22px;
  padding: 0px;
  width: 204px;
`

const FlexWrapper = styled(Flex)`
  flex-direction: column;
  ${props => props.theme.mediaQueries[0]} {
    flex: 1 1 50%;
  }
  ${props => props.theme.mediaQueries[3]} {
    flex: 1 1 66%;
  }
`

const Wrapper = styled(Card)`
  background-color: white;
`

const TiltStamp = styled(Stamp)`
  position: absolute;
  transform: translate(-14px, -8px) rotate(-28deg);
`

function gaTracking() {
  analytics.fireEvent({
    category: ANALYTICS_CATEGORY_HOME,
    action: 'Feature Box CTA',
    label: 'Hotel Collection Search'
  })
}

type InfoGraphicProps = {
  children: React.ReactNode
  contentText: string
}

const icon1Content = 'See 3 popular hotels at a heavily discounted price.'
const icon2Content = 'Click choose and we’ll pick one of the 3 hotels.'
const icon3Content = 'See which hotel right after you book!'

const InfoGraphic = ({ children, contentText }: InfoGraphicProps) => {
  return (
    <Flex
      px={1}
      flexDirection={['row', 'column']}
      width={[1, 1 / 2]}
      mt={[3, 0]}
    >
      <Box
        height={['56px', '92px']}
        mx={['none', 'auto']}
        textAlign="center"
        width={['56px', '96px']}
      >
        {children}
      </Box>
      <Text
        width={1}
        ml={['11px', 'auto']}
        mb={['auto', 0]}
        mt={['auto', 3]}
        textAlign={['left', 'center']}
        fontSize={1}
        fontWeight={[600, 400]}
      >
        {contentText}
      </Text>
    </Flex>
  )
}

const SearchButton = ({ handleClick }: { handleClick: () => void }) => (
  <StyledButton
    aria-label="Collections Promo Button"
    color="primary"
    variation="subtle"
    onClick={handleClick}
    width="20px"
  >
    Search Pricebreakers
  </StyledButton>
)

export default function PricebreakersPromo({
  isMobile = false
}: {
  isMobile?: boolean
}) {
  const [isModalOpen, setModalOpen] = useState(false)
  return (
    <Wrapper
      boxShadowSize="md"
      borderRadius="xl"
      width={[1, null, null, 2 / 3]}
    >
      <Flex flexDirection={['column', 'row']} style={{ height: '100%' }}>
        <TiltStamp color="text.lightest" bg="warning">
          New
        </TiltStamp>
        <FlexWrapper p={3}>
          <Flex justifyContent="space-between">
            <Text color="text" fontSize={[3, 5]} fontWeight="bold">
              Introducing
              <Text.span color="primary"> Pricebreakers</Text.span>
            </Text>
            {!isMobile && (
              <SearchButton
                handleClick={() => {
                  setModalOpen(true)
                  gaTracking()
                }}
              />
            )}
          </Flex>
          <Flex style={{ minHeight: '150px' }}>
            <Flex flexDirection={['column', 'row']} mt={[0, 4, 3]} mb={[2, 0]}>
              <InfoGraphic contentText={icon1Content}>
                <Image src={PricebreakersPromo1} alt="" loading="lazy" />
              </InfoGraphic>
              <InfoGraphic contentText={icon2Content}>
                <Image src={PricebreakersPromo2} alt="" loading="lazy" />
              </InfoGraphic>
              <InfoGraphic contentText={icon3Content}>
                <Image src={PricebreakersPromo3} alt="" loading="lazy" />
              </InfoGraphic>
            </Flex>
          </Flex>
          {isMobile && (
            <SearchButton
              handleClick={() => {
                setModalOpen(true)
                gaTracking()
              }}
            />
          )}
        </FlexWrapper>
      </Flex>
      <PromoModal
        ariaLabel="Pricebreakers Search Modal"
        primaryText="Search Pricebreakers"
        secondaryText="Our highest rated hotels - up to 50% off retail"
        isMobile={isMobile}
        isModalOpen={isModalOpen}
        onSubmit={handleSubmitForPricebreakers}
        onClose={() => {
          setModalOpen(false)
        }}
        promoDeal={PromoDeal.COLLECTIONS}
      />
    </Wrapper>
  )
}
